<template>
  <div>
    <van-button type="primary" @click="OnQRcode" block
      >点击按钮进行验证</van-button
    >
  </div>
</template>

<script>
import wx from "jweixin-module";
import { getJsSdkConfig } from "@/api/weChat";
import { Dialog } from "vant";
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  mounted() {
    this.isWechat();
  },
  methods: {
    isWechat() {
      const ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/micromessenger/i) == "micromessenger") {
        // return true;
        console.log("微信浏览器");
        this.scanQRJssdk();
      } else {
        console.log("普通浏览器,请在手机微信浏览器打开此页面");
        return false;
      }
    },
    // 初始化sdk配置
    scanQRJssdk() {
      const url = window.entryUrl || location.href.split("#")[0];
      getJsSdkConfig(url).then((resData) => {
        // 根据接口返回appId，timestamp等数据
        console.log("获取微信配置结果", resData);
        if (resData) {
          // alert(JSON.stringify(resData));
          wx.config({
            // beta: true,
            debug: false,
            appId: resData.data.appId,
            timestamp: resData.data.timestamp,
            nonceStr: resData.data.nonceStr,
            signature: resData.data.signature,
            jsApiList: ["checkJsApi", "scanQRCode", "uploadImage"],
          });
          wx.ready(() => {
            wx.checkJsApi({
              jsApiList: ["scanQRCode", "uploadImage"],
              success(res) {
                console.log("检查成功", res);
              },
            });
          });
          wx.error((res) => {
            alert(`出错了：${res.errMsg}`); // 这个地方的好处就是wx.config配置错误，会弹出窗口哪里错误，然		后根据微信文档查询即可。
          });
        }
      });
    },
    OnQRcode() {
      // 点击的时候调起扫一扫功能呢
      const _this = this;
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode", "pdf417"], // 可以指定扫二维码还是一维码，默认二者都有
        success(res) {
          const resultStrArr = res.resultStr.split(",");
          const zh = resultStrArr.find(
            (s) => s.startsWith("赣") && s.endsWith("号")
          );
          if (zh != null) {
            _this.$router.push({
              path: "/other/onlineScanCodeInfo",
              query: { zh: zh },
            });
          } else {
            Dialog.alert({
              message: "识别失败！",
            }).then(() => {});
          }
        },
        fail(res) {
          console.log("err", res);
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>